var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("访问地址不正确")]),_c('el-button',{staticClass:"login_button",attrs:{"type":"primary"},on:{"click":_vm.goToPage}},[_vm._v("回到首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }